import ViewRetailCashSales from "../../../../components/@documents/retail_cash_sales/ViewRetailCashSales";

import { routeTypes } from "../../../../hooks/useSystemRoutes";

export default function RetailCashSalesViewPage() {

    return (
        <ViewRetailCashSales 
            routeType={routeTypes.retail}
        />
    )
}